/**
 * Request persistent storage from the browser.
 * Prevents the browser from evicting IndexedDB/Cache data under storage pressure.
 */
export async function requestPersistentStorage() {
  if (!navigator.storage?.persist) {
    console.warn('[Storage] API persist non disponible');
    return;
  }

  try {
    const granted = await navigator.storage.persist();
    if (granted) {
      console.log('[Storage] Stockage persistant accorde');
    } else {
      console.warn('[Storage] Stockage persistant refusé — les données offline pourraient etre supprimées');
    }
  } catch (err) {
    console.warn('[Storage] Erreur lors de la demande:', err.message);
  }
}
